module.exports = __webpack_public_path__ + "static/img/linda_empty.f4b2f87.png";